<template>
  <div class="d-flex flex-column justify-content-center align-items-center col-md-12 router-view-report-background">
    <div class="col-md-12 px-0">
      <report-filters 
        :creators="creators"
        @add-animal="addAnimal"
      />
    </div>
    <div class="col-md-12 px-0">
      <the-table
        id="report-ril"
        :dataItems="computedBirth"
        :headers="headersForTable"
      >
        <template v-slot:actions="{item}">
          <v-btn 
            class="info" 
            @click="exportPDF(item)"
          >
            R.I.L
          </v-btn>
        </template>
      </the-table>
    </div>
    <modal-error
      :active="modalError"
      @close="modalError = false"
      :msgAlert="alertErrorMsg"
    />
  </div>
</template>

<script>
import ReportFilters from "./ReportFilters.vue";
import TheTable from "@/components/layout/TheTable.vue";
import {mapActions, mapState} from "vuex";
import openAuthenticatedPdf from "@/http/openPdf";
export default {
  name:"RilReport",
  components:{
    ReportFilters,
    TheTable,
    ModalError: () => import("./ModalError.vue")
  },
  data() {
    return {
      headersForTable:[
        {text:"Ordem", value:"order"},
        {text:"Data Parto", value:"date"},
        {text:"Qtde. Controles", value:"services_count"},
        {text:"Dt. Encerramento", value:"end_at"},
        {text:"", value:"actions", has_slot:true},
      ],
      animalsTable:[],
      animalToExport:{},
      modalError:false,
      alertErrorMsg:""
    }
  },
  computed: {
    ...mapState("report_ril", ["results"]),
    ...mapState("creators", ["creators"]),
    computedBirth() {
      return this.results.map(e => ({
        ...e,
        service_code:e.service ? "# " + e.service.code : "-",
        name:e.name_child,
      }));
    }
  },
  methods: {
    ...mapActions("creators", ["actionGetCreators"]),
    ...mapActions("report_ril", ["actionGetAllBirths", "actionCheckIfCanExportRill"]),
    // O bloqueio do RIL é checado no parto clicado; o PDF é do animal (todas as lactações).
    exportPDF(item) {
      const url = `${process.env.VUE_APP_URL_API}/v1/reports/${this.animalToExport.id}/ril`
      const guard = async () => {
        const permission = await this.actionCheckIfCanExportRill(item.id);
        if(!permission.valid) {
          this.alertErrorMsg = permission.msg;
          this.modalError = true;
        }
        return permission.valid;
      };
      openAuthenticatedPdf(url, guard).catch(() => this.$toast.error("Não foi possível abrir o RIL"))
    },
    async addAnimal(animal) {
      this.animalToExport = animal;
      await this.actionGetAllBirths(animal.id);
    }
  },
  async mounted() {
    await this.actionGetCreators();
  }
}
</script>